import React, { useState } from 'react';

const faqs = [
  {
    question: "It doesn't work! (Clearing your browser cache)",
    answer: `Sometimes, after we release new updates, your browser may still use old cached files. This can cause parts of the app to behave unexpectedly or not load correctly. If something doesn’t seem to work after an update, try clearing your browser cache and reloading the page. This forces your browser to fetch the newest version of the app and usually resolves the issue. If the problem continues even after clearing the cache, please contact us at the address provided below so we can help you further.`
  },
  {
    question: 'What video formats do you support?',
    answer: 'We support the most popular video formats: MP4, AVI, MOV, MKV and WebM.'
  },
  {
    question: 'Are my videos safe? Where are they stored?',
    answer: 'Yes, your videos are safe. Videos are uploaded directly to Cloudflare R2 storage and are automatically deleted after 24 hours. We never store them permanently.'
  },
  {
    question: 'What are the limits for unregistered users?',
    answer: `Unregistered users can process up to 3 videos in total. After reaching this limit, creating an account is required to continue using our services.`
  },
    {
      question: 'What are the limits for REGISTERED users (Free Tier)?',
      answer: `Registered users on the Free Tier can process up to 30 videos per day, with a maximum of 10 videos per hour. For Shot Extraction, each video can be up to 10 minutes long and up to 200 MB in size. For Video Merge, each video can also be up to 10 minutes and 200 MB, with a total combined size limit of 500 MB. We are preparing a premium tier with higher limits, and until it becomes available, users who need increased capacity can contact us at info@sceneextractor.com.`
    }




//   {
//     question: 'Čo je Legacy Premium a ako ho získam?',
//     answer: 'Legacy Premium je špeciálny tier pre našich prvých používateľov. Každý kto sa zaregistruje počas beta fázy dostane Legacy Premium natrvalo zadarmo! Zahŕňa vyššie limity: 100 videí/deň, 20/hodinu, 500MB na video.'
//   },
//   {
//     question: 'Ako dlho sú výsledky dostupné na stiahnutie?',
//     answer: 'Spracované videá a extrahované scény sú dostupné na stiahnutie 24 hodín po dokončení spracovania. Po tomto čase sú automaticky vymazané z bezpečnostných dôvodov.'
//   },
//   {
//     question: 'Môžem použiť službu na komerčné účely?',
//     answer: 'Áno, môžete použiť službu aj na komerčné projekty. Vaše spracované videá patria vám a máte plné práva na ich použitie.'
//   },
//   {
//     question: 'Čo je rozdiel medzi Shot Extraction a Video Merge?',
//     answer: 'Shot Extraction automaticky deteguje a extrahuje jednotlivé scény z vášho videa. Video Merge spojí viacero video klipov do jedného seamless videa. Obe funkcie sú dostupné zadarmo.'
//   }
];

const FAQItem = ({ faq, isOpen, onToggle }) => {
  return (
    <div className="border border-slate-600/50 rounded-lg overflow-hidden mb-4 bg-slate-700/30 hover:border-blue-500/50 transition-colors">
      <button
        onClick={onToggle}
        className="w-full text-left px-6 py-4 flex justify-between items-center"
      >
        <span className="text-lg font-medium text-white pr-8">
          {faq.question}
        </span>
        <span className="text-blue-400 text-2xl flex-shrink-0">
          {isOpen ? '−' : '+'}
        </span>
      </button>
      {isOpen && (
        <div className="px-6 pb-4">
          <p className="text-gray-300 leading-relaxed">
            {faq.answer}
          </p>
        </div>
      )}
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-slate-800/30">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-300">
            Do you have questions? We have answers.
          </p>
        </div>
        
        <div>
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              faq={faq}
              isOpen={openIndex === index}
              onToggle={() => toggleFAQ(index)}
            />
          ))}
        </div>
        
        <div className="mt-12 text-center">
          <p className="text-gray-400 mb-4">
            Didn't find the answer? Contact us at {' '}
            <a
                href="mailto:info@sceneextractor.com?subject=Feature%20Suggestion"
                className="text-blue-400 hover:text-blue-300 underline"
              >
                info@sceneextractor.com
              </a>
          </p>
          {/* Future: Contact form or email link */}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
